import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=0b93f97b"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports